import { FieldType } from 'utils/atsUtils'

export const GET_SCREENING_QUESTIONS = 'GET_SCREENING_QUESTIONS'
export const GET_SCREENING_QUESTIONS_PENDING = 'GET_SCREENING_QUESTIONS_PENDING'
export const GET_SCREENING_QUESTIONS_FULFILLED = 'GET_SCREENING_QUESTIONS_FULFILLED'
export const GET_SCREENING_QUESTIONS_REJECTED = 'GET_SCREENING_QUESTIONS_REJECTED'

export type ScreeningQuestionList = {
  id: number
  title: string
  question_type: FieldType
}

export type ScreeningQuestionData = {
  screening_questions: ScreeningQuestionList[]
}

export type ScreeningQuestionResponse = {
  data: ScreeningQuestionList[]
  org_total_question_count?: number
  success?: boolean
  statusCode?: number
}
